<template>
  <div>
    <div class="row">
      <div class="col-6 col-md-4" v-for="file in value" :key="'image-' + file.id">
          <img :src="file.url" :alt="file.file_name" class="img-fluid" v-if="!file.srcSet">
          <img :src="file.placeholder" :srcset="file.srcSet" :alt="file.file_name" class="img-fluid" v-if="file.srcSet">
      </div>
    </div>
    <div class="mt-2">
      <b-form-file v-model="newFile" accept="image/*" :key="ref" :ref="ref"></b-form-file>
      <loading-button variant="primary" block :loading="loading" class="mt-2" :disabled="!newFile" @submit="uploadFile" v-show="newFile">
        <font-awesome-icon icon="cloud-upload-alt"></font-awesome-icon>
        Upload
      </loading-button>
    </div>
  </div>
</template>

<script>
const uuidv1 = require('uuid/v1');

export default {
  name: 'CourseBuilderImage',
  data () {
    return {
      newFile: null,
      loading: false,
      ref: 'image-upload-' + uuidv1()
    };
  },
  methods: {
    uploadFile () {
      this.loading = true;
      let formData = new FormData();
      if (!Array.isArray(this.newFile))
        this.newFile = Array(this.newFile); // convert to array if single file

      this.newFile.forEach((file, idx) => formData.append(`file${idx}`, file));

      this.axios.post('/components/' + this.component_id + '/upload/image', formData).then(rsp => {
        this.$emit('input', [rsp.data.data]);
        this.loading = false;
        this.newFile = null;
        this.$refs[this.ref].reset();
        this.$snotify.success('File Uploaded');
      }).catch(err => {
        this.loading = false;
        this.$errorOut(err);
      });
    }
  },
  props: ['value', 'component_id']
};
</script>

<style scoped>

</style>